import React from 'react';
import Axios from 'axios';
import moment from 'moment';

import * as myConstClass from '../../shared/constants/constants';

const cstTableHeaders = [
	'Saison', 'Ligue', 'PJ', 'Vic', 'Def', '% Vic', 'PP', 'PC', 'Diff', 'Moy', 'EP', 'EC', 'PJ/EP',
	'TVP', 'TVC', 'IPS'];

const cstDefaultSortOrder = [
	'desc', 'asc', 'desc', 'desc', 'desc', 'desc', 'desc', 'desc', 'desc', 'desc', 'desc', 'desc', 'asc', 
	'desc', 'desc', 'desc'];

const cstDefaultSortFieldIdx = 0;
const cstFixedDecimalsStats = [
	{fieldIdx: 5, decimals: 1},
	{fieldIdx: 9, decimals: 2},
	{fieldIdx: 12, decimals: 1}
];

const cstEPPJColIdx = 12;

class DashMod_Summary01 extends React.Component {

  constructor(props) {
		super(props);

		this.state = {
			dataTable: [],
			compiledStats: [],
			sortFieldIdx: cstDefaultSortFieldIdx,
			sortOrder: cstDefaultSortOrder[cstDefaultSortFieldIdx],
			loading: true,
		};
	
		this.createTableHdrRow = this.createTableHdrRow.bind(this);
		this.createDataRow = this.createDataRow.bind(this);
		this.createDataCell = this.createDataCell.bind(this);
		this.handleSortTable = this.handleSortTable.bind(this);
	}

	componentDidMount() {
    //console.log('DashMod_Summary01: componentDidMount');
    if (this.props.playerId) {
    	this.loadData(this.props);
    }
	}

  componentDidUpdate(prevProps) {
    if (
      prevProps.playerId !== this.props.playerId ||
      prevProps.resultsType !== this.props.resultsType ||
      prevProps.leagueType !== this.props.leagueType
    ) {
      if (this.props.playerId) {
        this.loadData(this.props);
      }
    }
  }

	loadData(props) {
    // console.log('DashMod Summary01 - loadData');
    if (!props.playerId) return;

	  // -1 = no season selected
		Axios.get('/api/dashmod/summary/playerId/' + props.playerId + 
			'/resultsType/' + props.resultsType + '/leagueType/' + props.leagueType)

			.then(response => {
				var stats = response.data.stats;
				var compiledStats = response.data.compiledStats;
				this.setState({ compiledStats: compiledStats });
      	this.createDataTable(stats);
		});
	}

	createDataTable(stats) {
		var _this = this;
		var dataTable = [];

		// Parse results
		stats.forEach(function(result, resultIdx) {

			var dataTableRow = [];
			var moy = 0;
			if (result.games !== 0) {
				moy = result.pointsFor / result.games;	
			}

			dataTableRow.push(result.year);
			dataTableRow.push(result.seasonName);
			dataTableRow.push(result.games);
			dataTableRow.push(result.wins);
			dataTableRow.push(result.losts);
			dataTableRow.push(result.winPct);
			dataTableRow.push(result.pointsFor);
			dataTableRow.push(result.pointsAgainst);
			dataTableRow.push(result.pointsFor - result.pointsAgainst);
			dataTableRow.push(moy);
			dataTableRow.push(result.ero);
			dataTableRow.push(result.eroContre);
			dataTableRow.push(result.eroRate);
			dataTableRow.push(result.tv);
			dataTableRow.push(result.tvContre);
			dataTableRow.push(result.ips);

			// Build table
			dataTable.push(dataTableRow.slice());
		});

		// First data sort
		var sortFieldIdx = this.state.sortFieldIdx;
		var sortOrder = this.state.sortOrder;

		_this.sortdataTable(dataTable, sortFieldIdx, sortOrder);
	}

	sortdataTable(dataTable, sortFieldIdx, sortOrder) {
		// Manage empty data
		var _this = this;
		if (dataTable.length !== 0) {

			var sortSign = 1;
			if (sortOrder === 'desc') { 
				sortSign = -1; 
			}

			dataTable.sort(function(a, b) {

				var valueA = a[sortFieldIdx];
				var valueB = b[sortFieldIdx];
				var compVal = 0;

				var fact1 = 0;
				var fact2 = 0;
				var fact3 = 0;

				// Special case 
				if (sortFieldIdx === cstEPPJColIdx) {
					if (valueA === 0) {
						valueA = 9999;
					}
					if (valueB === 0) {
						valueB = 9999;
					}
				}

				switch(typeof valueA) {
			    case "string":
			    	// test if string is numeric
			    	if(_this.isNumeric(valueA) && _this.isNumeric(valueB)) {
							compVal = parseInt(valueA, 10) - parseInt(valueB, 10);
			    	} else {
							compVal = valueA.localeCompare(valueB);
						}
	  	      break;

			    case "number":
						compVal = valueA - valueB;
		        break;
				}

				fact1 = (sortSign * compVal);
				fact2 = (a[0].localeCompare(b[0]));
				fact3 = (a[1].localeCompare(b[1]));

				// Results
				if (fact1 !== 0) {
					return fact1;
				} else if (fact2 !== 0) {
					return fact2;
				} else {
					return fact3;
				}
			});
		}

		this.setState({
			dataTable: dataTable,
			sortFieldIdx: sortFieldIdx,
			sortOrder: sortOrder,
			loading: false
		});
	}

	render() {
		//console.log('DashMod_Summary01: render');
		if (!this.props.playerId) return null;

		return (
			<div className="row db-module-outer-dark">
			<div className="col-12">

				<div className="row">
				<div className="col-12 text-center">
					<h4 className="db-module-title-dark">Vos ligues et saisons</h4>
				</div>
				</div>
	
				<div className="row db-module-inner-dark">
				<div className="col-md-12 db-module-inner-col-padding">
				<div className="card db-module-inner-card-dark">
					{this.state.loading ?
						<div className="text-center margin-top-10">
							<i> données en chargement </i>
							{this.displaySpinner()}
						</div>
						: this.dispModule()
					}
				</div>
				</div>
				</div>
			</div>
			</div>
		)
	}

	dispModule() {
		var stats = this.state.stats;
		var compiledStats = this.state.compiledStats;

		var moy = 0;
		if (compiledStats.games !== 0) {
			moy = compiledStats.pointsFor / compiledStats.games;	
		}

		return (
			<div>
				<p>{this.state.dataTable.length} ligues </p>
				<div className="table-responsive">
					<table className="table table-striped table-hover table-sm tableFix2col">
					<thead>
						<tr>
							<th key={"head.rk"}>#</th>
							{cstTableHeaders.map(this.createTableHdrRow)}
						</tr>
					</thead>
					<tbody>
						{this.state.dataTable.length !== 0 ? 
							this.state.dataTable.map(this.createDataRow) : 
							this.createEmptyDataRow()}
					</tbody>

					<tbody>
						<tr className="headBackground">
							<td></td>
							<td className="text-uppercase">à vie</td>
							<td className="text-uppercase">toutes les ligues</td>
							<td>{compiledStats.games}</td>
							<td>{compiledStats.wins}</td>
							<td>{compiledStats.losts}</td>
							<td>{compiledStats.winPct.toFixed(1)}</td>
							<td>{compiledStats.pointsFor}</td>
							<td>{compiledStats.pointsAgainst}</td>
							<td>{(compiledStats.pointsFor - compiledStats.pointsAgainst)}</td>
							<td>{moy.toFixed(2)}</td>
							<td>{compiledStats.ero}</td>
							<td>{compiledStats.eroContre}</td>
							<td>{compiledStats.eroRate.toFixed(1)}</td>
							<td>{compiledStats.tv}</td>
							<td>{compiledStats.tvContre}</td>
							<td>{compiledStats.ips}</td>
						</tr>
					</tbody>

					</table>
				</div>
				<br/>
				{this.createLegend()}
			</div>
		);
	}

	createTableHdrRow(hdrItem, hdrIdx) {
		var classNameStr = '';
		var onClickAction = function() {};

		// Sort with arrows
		// No sort on Rank (column 0)
		if (cstDefaultSortOrder[hdrIdx] !== '') {
			onClickAction = this.handleSortTable;
			classNameStr = 'statelo-sorting';
			if(hdrIdx === this.state.sortFieldIdx) {
				if (this.state.sortOrder === "asc") {
					classNameStr += ' statelo-sorting_asc';
				} else {
					classNameStr += ' statelo-sorting_desc';
				}
			}
		}

		return (
			<th key={"colid." + hdrIdx}
				id={"colid." + hdrIdx} 
				className={classNameStr}
				onClick={onClickAction}>
				{hdrItem}
			</th>
		);
	}

  createDataRow(dataRow, dataRowIdx) {
		return (
			<tr key={'te.' + dataRowIdx}>
				<td key={"tdcell.rk"}>{dataRowIdx+1}</td>
				{dataRow.map(this.createDataCell)}
      </tr>
    );
  }

 	createDataCell(dataCell, dataCellIdx) {
		// Fixed number of decimals, converting to string, for averages or any other stats
		cstFixedDecimalsStats.forEach(function(fdItem, fdIOdx) {
			if (dataCellIdx === fdItem.fieldIdx) {
				dataCell = dataCell.toFixed(fdItem.decimals);
			}
		})

		if (dataCellIdx === cstEPPJColIdx) {
			if (parseInt(dataCell, 10) === 0) {
				dataCell = "---";
			}
		}

		return (
			<td key={"tdcell." + dataCellIdx}>{dataCell}</td>
		);
	}

	handleSortTable(e) {
		var _this = this;
		var sortFieldIdx = parseInt(e.target.id.split(".")[1], 10);

		var dataTable = this.state.dataTable;
		var sortOrder = this.state.sortOrder;
		var prevSortFieldIdx = this.state.sortFieldIdx;

		// Toggle sort order
		if (prevSortFieldIdx === sortFieldIdx) {
			if (sortOrder === 'asc') {
				sortOrder = 'desc';
			} else {
				sortOrder = 'asc';
			}
		} else {
			sortOrder = cstDefaultSortOrder[sortFieldIdx];
		}

		this.sortdataTable(dataTable, sortFieldIdx, sortOrder);
	}

  createEmptyDataRow() {
		return (
			<tr key={'te.0'}>
				<td colSpan="99">Aucune entrée</td>
	    </tr>
    );
  }

	createLegend() {
		return (
			<div className="row">
			<div className="col-md-8 col-xs-12">
				<div className="card">
					<div className="card-header">
					<i className="fa fa-th-large"></i>
						LÉGENDE
					</div>

				<div className="card-block">
				<table className="table table-striped table-sm">
				<tbody>
				<tr key='leg1'>
					<td><b>PJ</b></td>
					<td>Parties jouées</td>
					<td><b>Moy</b></td>
					<td>Moyenne (PP / PJ)</td>
				</tr>
				<tr key='leg2'>
					<td><b>Vic</b></td>
					<td>Victoires</td>
					<td><b>EP</b></td>
					<td>Ero pour</td>
				</tr>
				<tr key='leg3'>
					<td><b>Def</b></td>
					<td>Défaites</td>
					<td><b>EC</b></td>
					<td>Ero contre</td>
				</tr>
				<tr key='leg4'>
					<td><b>% Vic</b></td>
					<td>% de victoires</td>
					<td><b>PJ/EP</b></td>
					<td>Parties jouées par Ero pour</td>
				</tr>
				<tr key='leg5'>
					<td><b>PP</b></td>
					<td>Points pour</td>
					<td><b>TVP</b></td>
					<td>Tables vidées pour</td>
				</tr>
				<tr key='leg6'>
					<td><b>PC</b></td>
					<td>Points contre</td>
					<td><b>TVC</b></td>
					<td>Tables vidées contre</td>
				</tr>
				<tr key='leg7'>
					<td><b>Diff</b></td>
					<td>Différentiel (PP - PC)</td>
					<td><b>IPS</b></td>
					<td>Indice de Performance Statelo</td>
				</tr>
					
				</tbody>
				</table>
				</div>
				</div>
			</div>
			</div>
		);
	}

	displaySpinner() {
		return (
  		<div className="sk-three-bounce">
    		<div className="sk-child sk-bounce1"></div>
    		<div className="sk-child sk-bounce2"></div>
    		<div className="sk-child sk-bounce3"></div>
  		</div>
  	);
	}

	// isNumeric function in javascript
	isNumeric(n) {
		return !isNaN(parseFloat(n)) && isFinite(n);
	}

}

export default DashMod_Summary01;
